import { inject, Pipe, PipeTransform } from '@angular/core';

import { SortingService } from '@core/services/sorting.service';

@Pipe({ name: 'sort', standalone: true })
export class SortPipe implements PipeTransform {
  readonly #sortingService = inject(SortingService);

  /* eslint-disable @typescript-eslint/no-explicit-any */
  transform(
    list: any[],
    propertyName: string,
    direction: 'asc' | 'desc' = 'asc'
  ): any[] {
    return this.#sortingService.sort(list, propertyName, direction);
  }
}
